import React from 'react';

import SnippetEditor from './SnippetEditor';
import {tagEditorField} from "./snippetUtils";
import CommunicationSelectControl from './CommunicationSelectControl'

const EmailSnippetEditor = (props) => (
  <SnippetEditor
    {...props}
    fields={[
      {
        displayName: 'Name',
        canonicalName: 'name',
        condition: (snippet) => !snippet.standard
      },
      tagEditorField,
      {
        displayName: 'Default reply to',
        canonicalName: 'reply_to',
        tooltip: 'Separate multiple email addresses with commas',
      },
      {
        displayName: 'Default CC',
        canonicalName: 'cc_emails',
        tooltip: 'Separate multiple email addresses with commas',
        optional: true
      },
      {
        displayName: 'Default BCC',
        canonicalName: 'bcc_emails',
        tooltip: 'Separate multiple email addresses with commas',
        optional: true
      },
      {
        displayName: 'Subject',
        canonicalName: 'subject'
      },
      {
        displayName: 'Permission set',
        canonicalName: 'permissions',
        control: CommunicationSelectControl,
        tooltip: 'Set who is able to send this email template',
        optional: true,
        permissions: props.item.permissions,
        editable: true,
      }
    ]}
  />
)

export default EmailSnippetEditor;
